import React, { FC, Fragment, useEffect, useState } from 'react';
import HistoryTab from '../surge-tabs/history';
import { PolygonSurgeTabProps } from '../surge-tabs/types';
import { HistoryItemType } from '../surge-tabs/history/types';
import { Paginate } from '@cokitchen/cokitchen-components';
import { apiService } from 'utils/api';

const PolygonSurgeHistory: FC<PolygonSurgeTabProps> = ({ cokitchen_polygon_id }) => {
  const [loading, setLoading] = useState(false);
  const [historyList, setHistoryList] = useState<HistoryItemType[]>([]);
  const [pageCount, setPageCount] = useState<number>(1);
  useEffect(() => {
    fetchLogisticsData();
  }, [cokitchen_polygon_id]);

  const fetchLogisticsData = async (pageNo = 1) => {
    setLoading(true);
    try {
      const res = await apiService.post(
        `logistics/super-admin/surge/polygon/instant/get/${pageNo}`,
        { data: { cokitchen_polygon_id } }
      );
      const response = res?.data?.data;
      setHistoryList(response);
      setPageCount(Math.ceil(+res?.data?.total / 10));
    } finally {
      setLoading(false);
    }
  };

  const getSelectedPageData = async (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    await fetchLogisticsData(pageNo);
  };

  return (
    <Fragment>
      <HistoryTab color='blue' loading={loading} historyList={historyList} />
      {!loading && <Paginate pageCount={pageCount} onPageChange={getSelectedPageData} />}
    </Fragment>
  );
};

export default PolygonSurgeHistory;
